import { useState } from 'react';

import { useGlobalFiltersHook } from 'hooks/useGlobalFiltersHook';

import { useMutationSetWidgetColumns } from 'api/mutations/setWidgetColumns.mutation';
import { Risk, useQueryGetRiskRegister } from 'api/queries/getRiskRegister.query';

import { Risks } from 'components/widgets/RiskRegister/RiskRegister.utils';

export type UseRiskRegisterProvider = ReturnType<typeof useRiskRegisterProvider>;

export const useRiskRegisterProvider = ({
    widgetId,
    contractId,
    projectId,
    globalFilterData,
    sorting,
    latestVersionId,
}) => {
    const [status, setStatus] = useState<Risk['status'][]>([]);
    const [probability, setProbability] = useState<Risk['probability'][]>([]);
    const [risks, setRisks] = useState<Risks[]>([]);
    const [search, setSearch] = useState<string>('');
    const [tags, setTags] = useState<string[]>([]);

    const source = { ...globalFilterData, status, probability, search, sorting, risks, tags };

    return {
        ui: {
            state: getState({ contractId, projectId, source, sorting }),
            setters: {
                setStatus,
                setProbability,
                setSearch,
                setRisks,
                setTags,
            },
            pills: useGetPills({ source, widgetId }),
        },
        api: {
            riskRegister: useQueryGetRiskRegister({ contractId, metaDataId: latestVersionId }),
            setWidgetColumns: {
                instance: useMutationSetWidgetColumns(),
            },
        },
    };
};

const getState = ({ contractId, projectId, source, sorting }) => {
    return {
        contractId,
        projectId,
        sorting,
        status: source?.status,
        probability: source?.probability,
        search: source?.search,
        risks: source?.risks,
        tags: source?.tags,
    };
};

const useGetPills = ({ source, widgetId }) => {
    const pillsData = {
        Status: source?.status,
        Probability: source?.probability,
        Search: source?.search,
        Risks: source?.risks,
    };
    const { pillsList: pills } = useGlobalFiltersHook({ widgetId, source: pillsData, latestVersionId: undefined });

    return pills;
};
